const RoundedButton = ({
  onClick,
  image,
  title = null,
  className = '',
  badge = null
}) => (
  <div className='flex flex-col items-center'>
    <button
      type='button'
      onClick={onClick}
      className={`relative bg-white rounded-full flex flex-col items-center w-[3.625rem] h-[3.625rem] justify-center shadow-lg  ${className}`}
    >
      <img src={image} alt='' />
      {badge ? <div className='absolute -bottom-2'>{badge}</div> : null}
      {title ? <span className='sr-only'>{title}</span> : null}
    </button>
    {!!title && (
      <p className='mt-[10px] text-indigo-950 text-2xs font-bold font-manrope text-center w-16 row-start-2 row-end-3 leading-[120%]'>
        {title}
      </p>
    )}
  </div>
)

export default RoundedButton
